import * as React from "react";

// NPM
import { animated } from "react-spring";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";

// Utility
import Utility from "../domain/classes/Utility";

// Components
import StyledSectionContainer from "../components/common/SectionContainer.Component";
import { AnimatedGenericQuestionContainer } from "../components/patientAttributesQuestionaire/GenericQuestionContainer.Component";

// Contexts
import QuestionaireManager from "../contexts/QuestionaireManager.Context";

export const styles = (theme: Theme) => createStyles({ root: {}, stepper: {} });

export interface PatientAttributesQuestionaireSectionProps {}

const PatientAttributesQuestionaireSection = React.forwardRef<
	HTMLDivElement,
	PatientAttributesQuestionaireSectionProps & WithStyles<typeof styles>
>(({ classes }, ref) => {
	return (
		<StyledSectionContainer
			ref={ref}
			className={classes.root}
			maxWidth="xs"
		>
			<QuestionaireManager>
				<AnimatedGenericQuestionContainer />
			</QuestionaireManager>
		</StyledSectionContainer>
	);
});

const StyledPatientAttributesQuestionaireSection = withStyles(styles, {
	classNamePrefix: Utility.generateClassName(
		"PatientAttributesQuestionaireSection"
	),
})(PatientAttributesQuestionaireSection);

export default StyledPatientAttributesQuestionaireSection;

export const AnimatedPatientAttributesQuestionaireSection = animated(
	StyledPatientAttributesQuestionaireSection
);
